import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: 'auth',
  initialState: { code: '', accessToken: null, idToken: null, refreshToken: null, user: null, captain: null, trainingAssistant: null, profile: null, dispatch: null },
  reducers: {
    setCode: (state, action) => {
      state.code = action.payload;
    },
    setUserProfileDispatch: (state, action) => {
      const { captain, trainingAssistant, profile, dispatch } = action.payload;
      state.captain = captain;
      state.trainingAssistant = trainingAssistant;
      state.profile = profile;
      state.dispatch = dispatch;
    },
    setCredentials: (state, action) => {
      const { accessToken, idToken, refreshToken, user } = action.payload;
      state.accessToken = accessToken;
      state.idToken = idToken;
      state.refreshToken = refreshToken;
      state.user = user;
    },
    refresh: (state, action) => {
      state.code = 'refreshed';
      state.captain = null;
      state.trainingAssistant = null;
      state.user = null;
      state.accessToken = null;
      state.idToken = null;
    },
    logout: (state, action) => {
      state.code = 'invalidated';
      state.captain = null;
      state.trainingAssistant = null;
      state.accessToken = null;
      state.idToken = null;
      state.refreshToken = null;
      state.user = null;
    },
  }
});

export const { setCode, setUserProfileDispatch, setCredentials, refresh, logout } = authSlice.actions;
export default authSlice.reducer;
export const selectCurrentCode = (state: { auth: { code: any; }; }) => state.auth.code;
export const selectCurrentCaptain = (state: { auth: { captain: boolean; }; }) => state.auth.captain;
export const selectCurrentTrainingAssistant = (state: { auth: { trainingAssistant: boolean; }; }) => state.auth.trainingAssistant;
export const selectCurrentProfile = (state: { auth: { profile: any; }; }) => state.auth.profile;
export const selectCurrentDispatch = (state: { auth: { dispatch: any; }; }) => state.auth.dispatch;
export const selectCurrentAccessToken = (state: { auth: { accessToken: any; }; }) => state.auth.accessToken;
export const selectCurrentIdToken = (state: { auth: { idToken: any; }; }) => state.auth.idToken;
export const selectCurrentRefreshToken = (state: { auth: { refreshToken: any; }; }) => state.auth.refreshToken;
export const selectCurrentUser = (state: { auth: { user: any; }; }) => state.auth.user;